import { IRankingExtendedSearch } from "src/api/server/extended-search.types";
import { isRankingAvailable } from "src/components/pages/search/utils/is-ranking-available";
import { orderRankingsByFigureIds } from "src/components/pages/search/utils/order-rankings-by-figure-ids";

/**
 * Builds the rankings shown in the sort dropdown: the relevance ranking pinned
 * at the top, followed by every available ranking ordered to match the user's
 * selected key-figure order.
 */
export const getVisibleRankings = (
    rankings: ReadonlyArray<IRankingExtendedSearch>,
    relevanceRanking: IRankingExtendedSearch,
    selectedFigures: ReadonlyArray<string>
): ReadonlyArray<IRankingExtendedSearch> => {
    const selectedFiguresSet = new Set(selectedFigures);

    const availableRankings = orderRankingsByFigureIds(
        rankings.filter(ranking => isRankingAvailable(ranking, relevanceRanking, selectedFiguresSet)),
        selectedFigures
    );

    return [relevanceRanking, ...availableRankings];
};
